import { useFormik } from 'formik'
import * as Yup from 'yup'
import {
  ColorSelect,
  GradeSelect,
  SubjectSelect,
  Textarea,
} from 'src/components/common'
import InputField from 'src/components/formik/input-field'

const ClassroomForm = ({ onSubmit, initialValues }) => {
  const ClassroomSchema = Yup.object().shape({
    name: Yup.string().required('Required'),
    color: Yup.string().required('Required'),
    grade_id: Yup.string().nullable('Required').required('Required'),
    subject_id: Yup.string().nullable('Required').required('Required'),
  })

  const formik = useFormik({
    initialValues,
    validationSchema: ClassroomSchema,
    onSubmit,
  })

  return (
    <form onSubmit={formik.handleSubmit}>
      <div className="row">
        <div className="col-12 col-md-6">
          <InputField formik={formik} name="name">
            <label>Classroom name</label>
            <input
              name="name"
              onChange={formik.handleChange}
              value={formik.values.name}
              type="text"
            />
          </InputField>
        </div>
        <div className="col-12 col-md-6">
          <InputField formik={formik} name="color">
            <label>Select color</label>
            <ColorSelect
              value={formik.values.color}
              onChange={(val) => {
                formik.setFieldValue('color', val)
              }}
            />
          </InputField>
        </div>
      </div>

      <div className="row">
        <div className="col-12 col-md-3">
          <InputField formik={formik} name="subject_id">
            <label>Subject</label>
            <SubjectSelect
              value={formik.values.subject_id}
              onChange={(item) => {
                formik.setFieldValue('subject_id', Number(item?.value))
              }}
            />
          </InputField>
        </div>

        <div className="col-12 col-md-3">
          <InputField formik={formik} name="grade_id">
            <label>Grade</label>
            <GradeSelect
              value={formik.values.grade_id}
              onChange={(item) => {
                formik.setFieldValue('grade_id', Number(item?.value))
              }}
            />
          </InputField>
        </div>
      </div>

      {/* <div className="row">
        <div className="col-12 col-md-12">
          <InputField formik={formik} name='description'>
            <label>Description</label>
            <Textarea
              placeholder="Description"
              onChange={formik.handleChange}
              value={formik.values.description}
              name="description"
            />
          </InputField>
        </div>
      </div> */}

      <button
        type="submit"
        className="primary-btn"
        disabled={formik.isSubmitting}
      >
        {formik.isSubmitting ? 'Saving...' : 'Save'}
      </button>
    </form>
  )
}

export default ClassroomForm
